import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { RejectRegisterRequestParams } from './request';
import { rejectRegisterRequest } from './request';

export const useRejectRegisterRequestMutation = (
  settings?: MutationSettings<
    RejectRegisterRequestParams,
    typeof rejectRegisterRequest
  >
) =>
  useMutation({
    mutationKey: ['rejectRegisterRequest'],
    mutationFn: ({ config, params }) =>
      rejectRegisterRequest({
        params,
        config
      }),
    ...settings?.options
  });
